import NavMenu from './NavMenu.vue';

export default NavMenu;
